import { createAsyncThunk } from "@reduxjs/toolkit";
import * as URLS from "../../urls";
//axios
import axios from "../../utils/axios";
//----------------------------------------------------

// POST =>  add Exam Forms
export const addExamForms = createAsyncThunk(
  "samples/addExamForms",
  async (data, thunkAPI) => {
    try {
      const response = await axios.post(URLS.examFormsURL, data);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

// GET =>  get Exam Forms
export const getExams = createAsyncThunk(
  "samples/getExams",
  async (params, thunkAPI) => {
    console.log(params);
    try {
      const response = await axios.get(URLS.examFormsURL, {
        params: {
          ...params,
        },
      });
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

// POST =>  delete Exam Forms
export const deleteExam = createAsyncThunk(
  "samples/deleteExam",
  async (id, thunkAPI) => {
    try {
      const response = await axios.delete(`${URLS.examFormsURL}/${id}`);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

// POST =>  Add Question to Exam
export const addQuestionToExam = createAsyncThunk(
  "samples/addQuestionToExam",
  async (data, thunkAPI) => {
    try {
      const response = await axios.post(URLS.addQuestionURL, data);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

// GET =>  Get Questions Of Sample
export const getQuestionsOfSample = createAsyncThunk(
  "samples/getQuestionsOfSample",
  async (id, thunkAPI) => {
    try {
      const response = await axios.get(`${URLS.examFormsURL}/${id}`);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  }
);


// GET =>  Delete Questions Of Sample
export const deleteQuestionFromSample = createAsyncThunk(
  "samples/deleteQuestion",
  async (id, thunkAPI) => {
    try {
      const response = await axios.delete(`${URLS.deleteQuestionURL}/${id}`);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  }
);


// GET =>  ADD Image to question
export const addImageToQuestion = createAsyncThunk(
  "samples/addImageTpQuestion",
  async (data, thunkAPI) => {
    try {
      const response = await axios.post(URLS.addQuestionImageURL,data, {
        headers: {
            Accept: "*/*",
            "Content-Type": "multipart/form-data",
        },
    });
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  }
);
